<template>
    <div class="gridItem">
        <div class="simplefilter">
            <simplefilter v-if="simplefilter"
                @resetfilter="resetfilter"
                @success="querySimpleFilter"
                :contentType="contentType"
                :fieldDefinitions="simpleFilterDefinition">
            </simplefilter>
        </div>
        
        <div class="headTool" v-if="(showToolBar && selectCount == 0) || (!showToolBar)">
            <template v-if="showToolBar">
                <el-button size="default" 
                    @click="newItem" 
                    v-if="createAble" 
                    type="primary">
                    <el-icon><plus /></el-icon> 
                    {{ buttonSetting.NewName }}
                </el-button>
                <el-button size="default" 
                    @click="excelImportState = true" 
                    v-if="importAble">
                    <el-icon><download /></el-icon> 
                    {{ buttonSetting.ExcelName }}
                </el-button>
                <el-button size="default" 
                    @click="excelExport" 
                    v-if="exportAble">
                    <el-icon><upload /></el-icon> 
                    导出
                </el-button>
            </template>
            <span style="margin-left: auto;">
                <el-tooltip v-if="filterLoading"
                    class="box-item"
                    effect="dark"
                    placement="top">
                    <template #content > 已有高级查询条件生效 | <el-link :underline="false" type="primary" @click="resetfilter">清空</el-link> </template>
                    <el-button size="default" 
                        @click="filterState = true" 
                        style="color: #409EFC;">
                        <el-icon class="is-loading" color="#409EFC"><loading /></el-icon>
                        高级查询
                    </el-button>
                </el-tooltip>
                <el-button size="default" 
                    v-else="filterLoading" 
                    @click="filterState = true">
                    <el-icon><filtericon /></el-icon>
                    高级查询
                </el-button>

                <el-popover @show = "copyShowColumns"
                            @after-leave="handlerShowColumnOfChange"
                            placement="bottom"
                            width="200"
                            trigger="click">
                    <div style="height:250px;overflow-y:auto">
                        <el-checkbox class="showfield-span" 
                            v-model="allShowColumns"
                            @change="handleCheckAllShowColumn">
                            全选
                        </el-checkbox>
                        <el-checkbox-group v-model="showColumns" @change="handleCheckedShowColumnsChange ">
                            <el-checkbox class="showfield-span"
                                        v-for="(item,index) in showColumnOptions"
                                        :label="item.name"
                                        :value="item.name"
                                        :key="index">
                                {{ item.displayName }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <template #reference>
                        <el-button size="default" 
                            v-if="showColumns.length == showColumnOptions.length" 
                            style="color: #409EFC;"> 
                            <el-icon><view-icon color="#409EFC"/></el-icon> 
                            显示
                        </el-button>
                        <el-button size="default" 
                            v-else> 
                            <el-icon><view-icon/></el-icon> 
                            显示
                        </el-button>
                    </template>
                </el-popover>
                <el-button size="default" 
                    @click="fetchDataSource"> 
                    <el-icon><refresh /></el-icon> 刷新
                </el-button>
            </span>
        </div>

        <div class="headTool" v-if="selectCount != 0 && showToolBar">
            <el-button size="default" 
                @click="forceDeleteItems" 
                v-if="isAdmin" >
                <el-icon><delete /></el-icon> 
                强制删除
            </el-button>
            <el-button size="default" 
                @click="deleteItems" 
                v-if="batchDelete" 
                type="danger">
                <el-icon><delete /></el-icon> 
                {{ buttonSetting.BatchDeleteName }}
            </el-button>
            <el-button size="default" 
                v-for="item in noDetailUpdateItems"
                :loading="item.Loading"
                :key="item.ContentId"
                @click="batchUpdateContentItems(item)">
                {{ item.ButtonName }}
            </el-button>
            <el-button size="default" 
                v-for="item in noDetailCreateItems"
                :key="item.ContentId"
                @click="batchCreateContentItems(item)">
                {{ item.ButtonName }}
            </el-button>
            <el-button size="default" 
                v-for="item in noDetailPrintItems"
                :key="item.ContentId"
                @click="batchPrint(item)">
                {{ item.ButtonName }}
            </el-button>
            <el-dropdown v-if="detailPrintItems.length > 0 || detailItems.length > 0">
                <el-button size="default" >
                    更多操作<el-icon><more-filled /></el-icon>
                </el-button>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item v-for="item in detailPrintItems"
                            :key="item.ContentId"
                            @click="batchPrint(item)">
                            {{ item.ButtonName }}
                        </el-dropdown-item>
                        <el-dropdown-item v-for="item in detailItems"
                            :key="item.ContentId"
                            @click="batchPrint(item)">
                            {{ item.ButtonName }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>
        
        <div class="selectDiv headTool" v-if="batchAuth">
            <el-link type="primary" style="padding: 0 15px" :underline="false" @click="clearSelects">清空</el-link>
            <span>
                当前选中 <span class="selectCount"> {{ selectCount }} </span> 条数据
                {{ selectMap }}
            </span>
        </div>
        
        <div ref="grid" id="grid" :class="{'singleSelectGrid':isSingleSelect}"></div>

        <el-dialog v-model="filterState" 
                :close-on-click-modal="false"
                title="高级查询" 
                width="70%"
                append-to-body>
            <qwefilter @cancel="filterState = false"
                @resetfilter="resetfilter"
                @success="queryFilter"
                :guid = "filterLoaclKey"
                :contentType="contentType"
                :fieldDefinitions="middleFilterDefinition">
            </qwefilter>
        </el-dialog>

        <el-drawer size="90%" 
            :close-on-click-modal="false"
            class="qwe-grid-drawer"
            destroy-on-close 
            @closed="fetchDataSource"
            v-model="formItem.visibleState">
            <template #header><h2>{{ formItem.title }}</h2></template>
            <qweForm @[formEvent.operatorForm]="(operator, code)=> formSubmit(operator, code, 'formItem')"
                    @[formEvent.initForm]="fromInit"
                    :operation="formItem.operation"
                    :contentType="formItem.contentType"
                    :contentItemId = "formItem.contentItemId"
                    :flowCurrentNodeId="formItem.flowCurrentNodeId"
                    :passingParameter="formItem.passingParameter"
                    :is-show-head="false"></qweForm>
        </el-drawer>

        <el-drawer size="90%" 
            class="qwe-grid-drawer"
            destroy-on-close
            v-model="auditTrailItem.state">
            <template #header><h2>数据操作记录</h2></template>
            <contentAuditTrail :contentItemId="auditTrailItem.contentItemId"></contentAuditTrail>
        </el-drawer>

        <el-drawer size="85%" 
            class="qwe-grid-drawer qwe-custom-page"
            destroy-on-close
            :with-header="false"
            v-model="printItem.visibleState">
            <iframe class="frame-body" :src="printItem.url">
            </iframe>
        </el-drawer>

        <el-dialog v-model="updateItem.visibleState" 
                destroy-on-close
                class="qweFormDialog"
                :title="updateItem.title" 
                top="0" 
                width="70%"
                append-to-body>
            <template #header>
            <div class="dialog-title">
                <span class="main-title">{{ updateItem.title }}</span>
                <span class="sub-title">
                    <span>本次操作将修改 <span style="color: #E64340"> {{ selectCount }} </span> 条数据</span>
                </span>
            </div>
            </template>
            <qweForm @[formEvent.operatorForm]="updateSubmitForm"
                    isPropMode
                    :beforeSubmit="updateBeforeSubmit"
                    :propDatas="updateItem.propDatas"
                    :is-show-head="false"></qweForm>
        </el-dialog>

        <el-dialog v-model="createOtherItem.visibleState" 
                destroy-on-close
                class="qweFormDialog" 
                :title="createOtherItem.title" 
                top="0" 
                width="80%"
                append-to-body>
            <template #header>
            <div class="dialog-title">
                <span class="main-title">{{ createOtherItem.title }}</span>
            </div>
            </template>
            <qweForm @[formEvent.operatorForm]="(operator, code)=> formSubmit(operator, code, 'createOtherItem')"
                    @[formEvent.initForm]="fromInit"
                    :operation="createOtherItem.operation"
                    :contentType="createOtherItem.contentType"
                    :contentItemId = "createOtherItem.contentItemId"
                    :flowCurrentNodeId="createOtherItem.flowCurrentNodeId"
                    :passingParameter="createOtherItem.passingParameter"
                    :is-show-head="false"></qweForm>
        </el-dialog>

        <el-dialog v-model="excelImportState"
                destroy-on-close 
                class="import-dialog"
                title="导入" 
                top="9vh" 
                width="60%"
                append-to-body>
            <importItem :fatchDataSource = "finishImport"
                        @finish = "finishImport"
                        @init="initImport"
                        @closeimport="closeImport"
                        :contentType = "contentType"
                        :isSuperImport = "superImport"
                        :activities="superImportWorkflows"
                        :templatePath ="exportExcelPath"
                        :parameters="excelImportParameter"></importItem>
        </el-dialog>

        <el-dialog v-model="exportItem.excelExportState" 
                class="import-dialog"
                destroy-on-close 
                title="导出" 
                top="10vh" 
                width="40%"
                append-to-body>
            <exportItem @cancel="exportItem.excelExportState = false"
                        @success = "exportItem.excelExportState = false"
                        :contentType="contentType"
                        :filter="exportItem.filter"
                        :orginalFilter="exportItem.orginaldataFilter"
                        :sort="exportItem.sort"
                        :displayName="gridName"
                        :exportFields="exportItem.exportFields"></exportItem>
        </el-dialog>

        <el-drawer size="90%" 
            class="qwe-grid-drawer"
            destroy-on-close 
            v-model="gridItem.visibleState">
            <template #header><h2>{{ gridItem.title }}</h2></template>
            <qweGrid 
                :prop-filter="gridItem.filters"
                :gridId="gridItem.gridId">
            </qweGrid>
        </el-drawer>
    </div>
</template>

<style>
    /* .k-command-cell{
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        min-height: 0;
        overflow: auto; 
    } */


    .k-command-cell .k-button{
        margin-left: 0px !important;
    }

    .k-cell-inner>.k-link>.k-column-title{
        display: flex;
        align-items: center;
    }

    th[data-role="columnsorter"]>.k-cell-inner>.k-link>.k-column-title::after {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        margin-left: 4px;
        background-repeat: no-repeat;
        background-image: url(../../assets/status/sorting.svg);
    }

    th[data-role="columnsorter"]>.k-cell-inner>.k-link{
        cursor:pointer;
    }

    th.k-header.k-sorted>.k-cell-inner>.k-link>.k-column-title::after{
        content: "";
        width: 0;
        height: 0;
        background-image: none;
    }

    .singleSelectGrid .k-grid-header .k-checkbox {
        display: none;
    }

    .grid-fujian{
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .grid-fujian>a{
        color: #409eff;
        text-decoration: none;
    }

    .k-grid-lockedcolumns>.k-grid-header{
        padding-right: 0px !important;
    }
    .k-grid-header>.k-grid-header-wrap>table{
        padding-right: 17px !important;
    } 
    
    .label {
        display: inline;
        padding: .2em .6em .3em;
        font-size: 75%;
        font-weight: 700;
        line-height: 1;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: .25em;
    }

    .label-success {
        background-color: #5cb85c;
    }

    .label-danger {
        background-color: red;
    }

    .label-info {
        background-color: #5bc0de;
    }

    .k-grid-header-locked {
        float: right !important;
        border-right-width: 0px !important;
    }

    .k-grid-content-locked {
        float: right;
        border-right-width: 0px !important;
    }

    .k-grid-header-locked>table>thead>tr>th{
        padding-left: 20px !important;
    }

    .gridItem{
        height:100%;
    }
    
    .qweFormDialog{
        height:100%;
        margin-bottom: 0px !important;
        display: flex;
        flex-direction: column;
    }


    .qweFormDialog .el-dialog__body{
        height:100%;
        padding: var(--el-dialog-padding-primary);
        overflow-y: auto;
    }

    .qwe-custom-page>.el-drawer__body{
        padding: 0px !important;
    }

    .qwe-grid-drawer header{
        margin-bottom: 0px;
    }
    
    .qwe-grid-drawer header>h2{
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .k-button{
        padding: 4px 14px !important;
    }

    .k-grid-norecords-template{
        border: 0 !important
    }

    .batchChangeFieldMessageBox .el-message-box__status{
        top:13px;
        font-size: 30px !important;
    }

    .batchChangeFieldMessageBox .el-message-box__title{
        font-size: 16px;
        font-weight: 700;
    }
</style>

<style scoped>
   
    .selectDiv{
        border: 1px solid #91d5ff;
        background-color: #e6f7ff !important;
    }
    .selectCount{
        color: #096dd9;
    }
    .headTool {
        background-color: #F5F5F5;
        border-radius: 4px;
        padding: 10px;
        margin-bottom: 15px;
        display: flex;
        flex-wrap: wrap;
    }
    .footTool{
        display: -webkit-flex; 
        display: flex;
        align-items: center;
        background-color: #F5F5F5;
        padding: 10px;
        border-left:#ccc 1px solid;
        border-right:#ccc 1px solid;
        flex-wrap: wrap;
    }
    .showfield-span{
        display:block;
        width:100%;
        margin-right: 0!important
    }
    .main-title {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        margin-right: 12px;
        color: #1f2d3d;
        font-weight: 700;
        font-size: 16px;
    }
    .sub-title {
        color: #91a1b7;
        font-size: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>

<script>
    import ImportItem from '../Import/ImportItem.vue'
    import GridItem from './GridItem'
    import ExportItem from '../Export/ExportItem.vue'
    import { Search, View, Plus, Download, Upload, Delete, MoreFilled, Filter, Refresh, Loading, Sort } from '@element-plus/icons-vue'
    import qweForm from "../../components/Form/FormItem.vue"
    import QweFilter from '../Filters/Pc/MiddleFilter.vue'
    import QweSimpleFilter from '../Filters/Pc/SimpleFilter.vue'
    import ContentAuditTrail from '../AuditTrail/ContentAuditTrail.vue'
    import baseGrid from "./GridItem"
    import { forceDeleteContentItems, workFlowExe } from "../../apis/httpHelper"
    import { GridEvent } from "."
    import { qweIsEmpty } from "../../common/commonHelper"

    var dataSourceList = {};
    export default {
        name:"qweGrid",
        mixins:[baseGrid],

        data:function(){
            return {
                gridItem:{
                    visibleState: false,
                    title: "",
                    gridId: "",
                    filters: {}
                },
                gridEvent:GridEvent
            };
        },
        
        components:{
            "filtericon": Filter,
            "search": Search,
            "view-icon": View,
            "plus": Plus,
            "upload": Upload,
            "download": Download,
            "delete": Delete,
            "more-filled": MoreFilled,
            "qweForm": qweForm,
            "importItem": ImportItem,
            "exportItem": ExportItem,
            "qwefilter": QweFilter,
            "simplefilter": QweSimpleFilter,
            "refresh": Refresh,
            "loading": Loading,
            "contentAuditTrail":ContentAuditTrail,
            "Sort":Sort,
            "qweGrid":GridItem,
        },

        beforeUnmount:function(){
            if($(this.$refs.grid).data("kendoGrid")){
                $(this.$refs.grid).data("kendoGrid").destroy();
                $(this.$refs.grid).empty();
                delete dataSourceList[this.dataSourceId];
            }
        },

        methods:{
            closeImport:function(){
                this.excelImportState = false;
            },

            forceDeleteItems:async function(){
                let contentItemIds = this.getContentItemIds();
                let that = this;
                if(contentItemIds.length == 0){
                    this.$message.error("当前未选中任何数据");
                } 
                else{
                    try {
                        await this.$prompt(
                            '将对 <span style="color:rgb(245, 108, 108)">' + contentItemIds.length + '</span> 条数据执行 <span style="color:rgb(245, 108, 108)">强制删除</span> 操作, 此操作无法还原，'+
                            '<div style="margin-top:5px">如确定删除，请请输入当前报表Id：</div>', 
                            '提示', 
                            {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                dangerouslyUseHTMLString: true,
                                inputValidator:function(value){
                                    return value == that.gridId;
                                },
                                inputErrorMessage:"Id输入错误",
                                type: 'warning'
                            }
                        );
                        let response = await forceDeleteContentItems(contentItemIds);
                        this.$message.success("强制删除成功" + response.Result + "条数据");
                        this.fetchDataSource();
                    } catch (error) {
                        console.log(error)   
                    }
                }
            },

            handleCheckAllShowColumn:function(val){
                if(val){
                    this.showColumns = this.showColumnOptions.map(x=>x.name)
                }
                else{
                    this.showColumns = [];
                }
            },

            handleCheckedShowColumnsChange:function(val){
                this.allShowColumns = val.length == this.showColumnOptions.length;
            },

            editLinkContentItem:function(contentItemId){
                this.formItem.operation = "Edit";
                this.formItem.contentItemId = contentItemId;
                this.formItem.visibleState = true;
            },


            /**
             * 单条打印
             * @param { object } actionContext 当前动作上下文
             * @param { string } dataItemId 数据Id
             */
            singlePrint:function(actionContext, dataItemId){
                window.open(this.$store.state.baseUrl + "/Qwe.ContentFlow.Print/Print/Index?TemplateId="+ actionContext.Print.Url + "&DataId=" + dataItemId, "_blank")
            },

            /**
             * 打开一个自定义页面
             * @param { object } actionContext 当前动作上下文
             * @param { string } dataItemId 数据Id
             */
            singleOpenDrawer:function(actionContext, dataItemId){
                this.printItem.title = actionContext.ButtonName;
                this.printItem.url = this.$store.state.baseUrl + "/Qwe.ContentFlow.Print/Print/Index?TemplateId="+ actionContext.Print.Url + "&DataId=" + dataItemId;
                this.printItem.visibleState = true;
            },

            /**
             * 请求工作流
             * @param { object } actionContext 当前动作上下文
             * @param { string } dataItemId 数据Id
             */
            singleRequestWorkFlow:async function(actionContext, dataItemId){
                if(actionContext.Workflow.Confirm){
                    this.$messageBox.alert("你确定执行"+ actionContext.ButtonName +"操作吗？",actionContext.ButtonName,{
                        showCancelButton: true,
                        type: 'warning'
                    }).then(x=>{
                        this.toRequestWorkflow(actionContext, dataItemId);
                    }).catch(x=>{

                    }) 
                }
                else{
                    this.toRequestWorkflow(actionContext, dataItemId);
                }
            },

            /**
             * 执行工作流
             * @param { object } actionContext 当前动作上下文
             * @param { string } dataItemId 数据Id
             */
            toRequestWorkflow:function(actionContext, dataItemId){
                workFlowExe(actionContext.Workflow.WorkflowStartId, { DataId:dataItemId }).then(response=>{
                    if(!qweIsEmpty(response.Result)){
                        this.$message.success(response.Result)
                    }
                    else{
                        this.$message.success(actionContext.ButtonName)
                    }
                    if(actionContext.Workflow.FlushData){
                        this.fetchDataSource();
                    }
                }).catch(error=>{
                    this.$message.error("操作失败，系统异常");
                })
            },

            /**
             * 创建一条新类型的内容项
             * @param { object } actionContext 当前动作上下文
             * @param { string } dataItemId 数据Id
             */
            singleCreateContent:function(actionContext, dataItemId){
                this.getSelectItems(dataItemId)
                    .then(x=>{
                        let selectItem = x.Result.data[0];
                        this.context.Properties.Selects = x.Result.data;
                        this.context.Content = selectItem;
                        let item = actionContext.CreateContent;
                        if(this.batchCheckItems(item.CheckItems, this.context)){
                            this.createOtherItem.title = actionContext.ButtonName;
                            this.createOtherItem.operation = "Create";
                            this.createOtherItem.contentType = item.ContentType;
                            
                            this.createOtherItem.passingParameter = this.handlerPassingParameter(item.BatchFields);
                            this.createOtherItem.visibleState = true;
                        }
                    })
            },

            /**
             * 更新当前类型内容项
             * @param { object } actionContext 当前动作上下文
             * @param { string } dataItemId 数据Id
             */
            singleUpdateContent:function(actionContext, dataItemId){
                actionContext.Update.ButtonName = actionContext.ButtonName;
                this.batchCreateContentItems(actionContext.Update, dataItemId);
            },

            /**
             * 打开一个自定义查询页面
             * @param { object } actionContext 当前动作上下文
             * @param { string } dataItemId 数据Id
             */
            singleOpenGrid:function(actionContext, dataItemId){
                this.getSelectItems(dataItemId).then(x=>{
                    let selectItem = x.Result.data[0];
                    this.context.Properties.Selects = x.Result.data;
                    this.context.Content = selectItem;
                    let script = actionContext.Grid.Script;
                    let func = new Function("Context", "Content", script);
                    let result = func(this.context, selectItem);
                    let gridId = result.gridId;
                    let filters = result.filters;


                    this.gridItem.title = actionContext.ButtonName;
                    this.gridItem.gridId = gridId;
                    this.gridItem.filters = filters;
                    this.gridItem.visibleState = true;
                })
            },
        }
    }
</script>